import { render, staticRenderFns } from "./BannerCreateAndFilter.vue?vue&type=template&id=18de435b&scoped=true&"
import script from "./BannerCreateAndFilter.vue?vue&type=script&lang=js&"
export * from "./BannerCreateAndFilter.vue?vue&type=script&lang=js&"
import style0 from "./BannerCreateAndFilter.vue?vue&type=style&index=0&id=18de435b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de435b",
  null
  
)

export default component.exports